import React from 'react';
import { Box, FormControl, FormLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { Asterisk } from 'components/modals/addPostModal/PostDetailsForm';
import { FormHelperText } from '@mui/material';
import Editor from 'components/common/editor/Editor';
import { FeedbackFormData } from '../../../pages/projects/hooks/useFeedbackForm';
import FeedbackAttachments from './FeedbackAttachments';

const FeedbackForm: React.FC = () => {
  const {
    formState: { isSubmitting },
    control,
    setValue,
  } = useFormContext<FeedbackFormData>();

  return (
    <>
      <Box pt={1}>
        <FormLabel
          sx={{
            color: 'inherit',
            fontWeight: 700,
          }}
        >
          Feedback <Asterisk>*</Asterisk>
        </FormLabel>
        <Box mt={1}>
          <Controller
            control={control}
            render={({ field: { ref, onChange, ...field }, fieldState }) => (
              <FormControl fullWidth>
                <Editor
                  {...field}
                  onEditorChange={onChange}
                  value={!!field.value.trim() ? field.value : ''}
                  disabled={isSubmitting}
                  init={{
                    max_height: 450,
                    min_height: 300,
                    height: 300,
                    placeholder: 'Description',
                    auto_focus: true,
                  }}
                  onBlur={() => {
                    field.onBlur();
                    setValue('description', field.value.trim());
                  }}
                />
                <FormHelperText error>{fieldState.error?.message || ''}</FormHelperText>
              </FormControl>
            )}
            name="description"
          />
        </Box>
      </Box>
      <Box>
        <FeedbackAttachments />
      </Box>
    </>
  );
};

export default FeedbackForm;
